import { postV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryInitiate } from 'src/client/spendesk-api';
import { type PostV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryInitiateRequest } from 'src/client/spendesk-api-types';
import { logger } from 'src/utils/datadog-log-wrapper';

export type PostInitiateRecoveryFactorScaInput = {
  companyId: string;
  userId: string;
  authenticationMethod: PostV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryInitiateRequest['body']['authenticationMethod'];
};

export const postInitiateRecoveryFactorSca = async (
  input: PostInitiateRecoveryFactorScaInput,
) => {
  const { statusCode, body } =
    await postV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryInitiate({
      path: {
        companyId: input.companyId,
        userId: input.userId,
      },
      body: {
        authenticationMethod: input.authenticationMethod,
      },
    });
  if (statusCode !== 200) {
    logger.error('Failed to initiate recovery factor SCA.', {
      error: body,
      scope: 'user-authentication-factors',
      team: 'cards-ux',
    });
    throw new Error('Failed to initiate recovery factor SCA.');
  }
  return body;
};
